import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';

// Thunks - actions that return a function that accepts a dispatch
export const clearSampleWeighted = targetGrid => ({
  type: types.CLEAR_REPORTS_SAMPLE_WEIGHTED,
  targetGrid,
});

// Thunks - actions that return a function that accepts a dispatch
export const updateSampleWeighted = (gridData, targetGrid) => ({
  type: types.UPDATE_REPORTS_SAMPLE_WEIGHTED,
  gridData,
  targetGrid,
});

export const clearSampleWeightedKPIs = () => ({
  type: types.CLEAR_SAMPLE_WEIGHTED_QUICKREPORTS_KPI,
});

// Thunks - actions that return a function that accepts a dispatch
export const clearReport = () => ({
  type: types.CLEAR_REPORT,
});

export const clearWeightType = () => ({
  type: types.CLEAR_SELECTED_WEIGHT_QUICK_REPORT,
});
// Thunks - actions that return a function that accepts a dispatch
export const selectReport = report => ({
  type: types.SELECT_REPORT,
  report,
});

// Thunks - actions that return a function that accepts a dispatch
export const clearAllReport = () => ({
  type: types.CLEAR_ALL_REPORT,
});

// Required Parameters: targetGrid, token, uid, accountId, productNo,
// weightType, divisor, expressionList, selectedNames
// Optional Paramaters: sourceGrid, gridData, titlePrefix, originalNames
export function getSampleWeighted({
  sourceGrid,
  targetGrid,
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  selectedNames,
  gridData,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
}) {
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList,
      },
    })
      .then(response =>
        dispatch({
          type: types.GET_REPORTS_SAMPLE_WEIGHTED,
          payload: response.data.data,
          gridData,
          sourceGrid,
          targetGrid,
          selectedNames,
          expressionList,
          titlePrefix,
          originalNames,
          objSmartSearchArray
        }),
      )
      .catch(response => console.warn(response));
  };
}

export function runQuickReports({
  token,
  uid,
  accountId,
  reportName,
  productNo,
  weightType,
  divisor,
  customWeights,
  targetLabel,
  targetExpression,
  baseLabel,
  baseExpression,
  subType,
  combos,
  incrementalReach,
  selectedWeight,
  indexGroupCount,
  minIndex,
  maxIndex,
}) {
  if (reportName === 'CHANCAT') {
    reportName = 'CCAT_7';
  }
  const url = `${urls.ROOT_URL}/reports/clientreport/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        reportName,
        productNo,
        weightType,
        divisor,
        customWeights,
        targetLabel,
        targetExpression,
        baseLabel,
        baseExpression,
        subType,
        combos,
        incrementalReach,
        indexGroupCount,
        minIndex,
        maxIndex,
      },
    })
      .then(response =>
        dispatch({
          type: types.RUN_REPORT,
          payload: {
            reportName,
            ...response.data.data,
            baseExpression,
            baseLabel,
            targetExpression,
            targetLabel,
          },
          selectedWeight,
        }),
      )
      .catch(response => console.warn(response));
  };
}

export function exportQuickReports({
  token,
  uid,
  accountId,
  reportName,
  productNo,
  weightType,
  divisor,
  customWeights,
  targetLabel,
  targetExpression,
  baseLabel,
  baseExpression,
  option,
  subType,
  combos,
  incrementalReach,
  categoryCount,
  remove,
  selectedWeightName,
  fileName,
}) {
  const url = `${urls.ROOT_URL}/reports/exportclientreport/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        reportName,
        productNo,
        weightType,
        divisor,
        customWeights,
        targetLabel,
        targetExpression,
        baseLabel,
        baseExpression,
        option,
        subType,
        combos,
        incrementalReach,
        categoryCount,
        remove,
        selectedWeightName,
        fileName,
      },
    })
      .then(response =>
        dispatch({
          type: types.EXPORT_REPORT,
          payload: { reportName, ...response.data.data },
        }),
      )
      .catch(response => console.warn(response));
  };
}

export const addExportQuickReportsParmstoRedux = ({
  option,
  subType,
  combos,
  incrementalReach,
  categoryCount,
  remove,
}) => ({
  type: types.ADD_QUICKREPORT_PARAMS_REDUX,
  payload: { option, subType, combos, incrementalReach, categoryCount, remove },
});

export const updateMapSettings = (key, value) => dispatch => {
  dispatch({
    type: types.UPDATE_MAP_SETTINGS,
    key,
    value,
  })
}

export const setQuickReportRunFlag = (data) => dispatch => {
  dispatch({
    type: types.SET_QUICK_REPORT_FLAG,
    payload: data
  })
}